module.exports = __webpack_public_path__ + "media/108.2d081810.wav";